import { CircularProgress } from "@mui/material";

export default function LoadingView({ label = "Yükleniyor..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-8 gap-3">
      <CircularProgress size={32} />
      <div className="text-base text-terakkiNeutral dark:text-white/70">{label}</div>
    </div>
  );
}
